const scrollTo = (top = 0) => {
  if (window.scroll) {
    window.scroll({ top, behavior: 'smooth' });
  } else if (window.parent && window.parent.scroll) {
    window.parent.scroll({ top, behavior: 'smooth' });
  }
};

export default scrollTo;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/lib/utils/scrollTo.js